import React, { useEffect, useRef, useState } from 'react'
import ReactDOM from 'react-dom'
import { useDispatch, useSelector } from 'react-redux'
import PopupEnum from '../../base/PopupEnum'
import { LanguageService } from '../../../services/LanguageService'
import { changePopupVisibility } from '../../../actions/UserActions'
import PlayerVerificationHelper from '../../../services/helpers/PlayerVerificationHelper'
import { getUnverifiedUserReminder } from '../../../actions/settings/SettingsAction'
import './_unverified_user_reminder.scss'
import { ReactComponent as UnverifiedUserSVG } from '../../../assets/img/general/unverifyed.svg';
import { useDeviceType } from '../../../hooks'

function UnverifiedUserReminder() {
    const dispatch = useDispatch()
    const { playerData = {} } = useSelector(state => state.user);
    const getUnverifiedFilds = PlayerVerificationHelper.getUnVerifiedFilds(playerData.player);
    const isUnverifiedUserReminderOpen = useSelector(state => state.settings.isUnverifiedUserReminderOpen)
    const { isMobile } = useDeviceType()

     const handlePopupClose = () => {
        dispatch(getUnverifiedUserReminder({isUnverifiedUserReminderOpen: false}))
      }

    const openAccountMenu = () => {
        dispatch(isMobile ? changePopupVisibility(PopupEnum.AccountMenu) : changePopupVisibility(PopupEnum.MyProfile))
        dispatch(getUnverifiedUserReminder({isUnverifiedUserReminderOpen: false}))
    }


    return (
      isUnverifiedUserReminderOpen ? ReactDOM.createPortal(<div className="tb--modal-lvl1">
            <div className="tb--modal-lvl2">
              <div className="tb--modal-lvl3 reminder_popup__wrapper">
                <div className='tb--modal-popup reminder_popup'>
                  <div className='close-btn tb--cp'><i className='digi_icon-close ' onClick={handlePopupClose}></i></div>
                  <div className='tb--modal-image'>
                    <UnverifiedUserSVG />
                  </div>
                  <h5 className='reminder_popup_title'>{LanguageService.getTranslation('verificationReminderTitle', 'account')}</h5>
                  <div className='reminder_popup_text'><p dangerouslySetInnerHTML={{ __html: LanguageService.getTranslation('unverifiedPlayerInfo', 'account', [`<strong> ${getUnverifiedFilds.map(el => ` ${LanguageService.getTranslation(el, 'account')}`)}</strong>`]) }}></p></div>
                  <button className='reminder_popup_btn tb--btn tb--btn-text tb--btn-ternary tb--text_upercase tb--w_100' onClick={openAccountMenu}>{LanguageService.getTranslation('verifyButton', 'general')}</button>
                
                </div>
              
              </div>
            </div>
          </div>, document.getElementById('modal-root')) : <></>
    )
}

export default UnverifiedUserReminder